<template>
	<div>
		<router-view v-if="$route.meta.loginFree || (saasInfo && userInfo)"></router-view>
	</div>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		name: 'App',

		computed: {
			...mapState(['session', 'saasInfo', 'userInfo'])
		},

		watch: {
			$route() {
				this.globalDialogDestroy();
			}
		},

		created() {
			if (/Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
				location.href = '/app';
				return;
			}
			document.body.ondrop = function (event) {
				event.preventDefault();
				event.stopPropagation();
			}
			this.session && this.$store.dispatch('updateLoginInfo');
			this.$store.dispatch('updateSystemConfig');
		}
	}
</script>

<style lang="stylus">
	@import './assets/style/reset';
	@import './assets/style/fonts';

	@media print {
		body .g-page,
		.c-notice,
		.c-message,
		.c-popup-mask,
		.c-dialog-wrapper {
			display: none;
		}

		.print-body {
			display: block !important;
		}
		.print-page {
			box-sizing: border-box;
			overflow: hidden;
			font-size: 10pt;

			&:nth-last-child(n+2) {
				page-break-after: always;
			}

			&[border="0"] {
				table, td {
					border-color: #fff;
				}
			}
			
			table {
				width: 100%;
				max-width: 100%;
				border: .2mm solid #000;

				td {
					vertical-align: middle;
					border: .2mm solid #000;
					padding: 1.5mm;
					word-break: break-all;

					img {
						vertical-align: middle;
					}
				}
			}	
		}
	}

	.c-button[color=main]:not([hollow]):not([disabled]) {
		border: none !important;
		background: linear-gradient(90deg, #3D5EFF, #0078FF) !important;

		&:hover {
			opacity: .9;
		}
	}
	
	.c-input,
	.c-select,
	.c-datetime {
		box-shadow: inset 0 2px 4px #eee;
	}

	.c-radio {
		display: flex !important;
		align-self: center;
		justify-content: center;
		position: relative;
		box-sizing: border-box;
		min-width: 100px;
		height: auto !important;
		border: 1px solid #F5F5F5;
		border-radius: 4px;
		padding: 0 16px;
		margin: 0 !important;
		overflow: hidden;
		background: #F5F5F5;

		&.z-chk {
			border-color: var(--color-main);
			color: var(--color-main) !important;
			background: #fff;

			&:after {
				content: '\e63f';
				position: absolute;
				right: 1px;
				bottom: 1px;
				font-family: 'iconfont';
				font-size: 8px;
				color: #fff;
			}

			&:before {
				content: '';
				position: absolute;
				right: 0;
				bottom: 0;
				border-bottom: 18px solid var(--color-main);
				border-left: 20px solid rgba(255,255,255,0);
			}
		}

		&.z-dis {
			background: #F5F5F5;

			&:after {
				color: #bbb;
			}
		}

		&-group {
			gap: 10px;
			display: flex !important;
			flex-wrap: wrap;
			margin-top: 0 !important;
		}

		&-check {
			display: none !important;
		}

		&-content {
			margin: 0 !important;
			line-height: 36px !important;

			^[-1].z-chk ^[-2..-1] {
				font-weight: normal !important;
			}

			^[-1].z-dis ^[-2..-1] {
				color: #aaa;
			}
		}
	}

	.m-search-item,
	.c-table-body {
		.c-input,
		.c-select,
		.c-datetime {
			box-shadow: none;
		}
	}

	.g-page .g-content {
		background: #F0F2F5 !important;
	}

	.c-button {
		.icon {
			line-height: 1.1;
			font-size: 1.2em;
		}
	}
	
	.c-module-content {
		> .c-title {
			padding: 0 20px;
		}

		> .c-table:nth-child(1) {
			margin-top: -1px;
		}
	}
	
	.c-table-body {
		.c-input {
			height: 30px;
			background: #FFFAAD;
			
			input {
				padding: 0 5px;
				font-size: 13px;
			}
		}
		
		.c-select {
			height: 30px;
			background: #FFFAAD;
			
			&-main {
				padding-left: 5px;
			}
			
			&-current {
				font-size: 13px;
			}
			
			input {
				background: none;
			}
		}

		.c-datetime {
			height: 30px;
			background: #FFFAAD;
			
			input {
				font-size: 13px;
			}
		}
	}
	
	.c-table table thead tr th {
		padding-left: 5px;
		padding-right: 5px;
		font-size: 14px;
	}
	.c-table table tbody tr td {
		padding: 6px 5px;
		font-size: 14px;
	}

	.c-table-button-more ul {
		box-shadow: 0 0 10px 0 rgba(0,0,0,.15);

		li {
			font-size: 13px;
		}
	}

	.c-table-button {
		gap: 4px;

		&-item {
			border: none;
			border-radius: 2px;
			padding: 0 6px;
			line-height: 26px;
			font-size: 14px;
			background: none;
			color: #0078FF;

			&[disabled] {
				background: none;
			}

			&:not([disabled]):hover {
				color: #0078FF;
				background: #EBF4FF;
			}
		}

		&-more {
			&:before {
				content: '\e6df';
				font-family: 'iconfont';
				font-size: 14px;
			}
		}

		&-tri {
			display: none;
		}
	}

	.c-form {
		> .c-title {
			box-sizing: border-box;
			width: 100%;
		}
	}

	.c-pagination {
		height: 40px !important;
	}

	.c-message p {
		max-width: 14em !important;
	}

	.c-form {
		.c-title:nth-child(n+2) {
			margin-top: 10px;
		}
	}

	.c-detail-item:nth-last-child(n+2)  {
		flex-grow: initial;
	}

	.c-dialog {
		.c-tab-list ul[type=border-tab] {
			background: #FAFAFA;

			li.z-crt {
				background: linear-gradient(0deg, #FFFFFF 40%, #F2FFFC);
			}
		}
	}

	.m-detail {
		&-tag {
			gap: 6px;
			margin-left: 16px;

			label {
				border: 1px solid #bbb;
				border-radius: 2px;
				padding: 0 6px;
				line-height: 22px;
				font-size: 12px;
				color: #666;
			}
		}

		&-form {
			padding: 0;

			.c-detail-content {
				border: none;
			}

			.c-detail-item {
				border-left: none;

				&-label {
					width: 100px;
				}
			}
		}

		&-box {
			display: flex;
			flex-direction: column;
			flex-grow: 1;
			gap: 6px;
			padding: 20px;

			.c-title:nth-child(n+2) {
				margin-top: 10px;
			}

			.custom-table {
				width: 100%;

				&.flex-grow {
					min-height: 200px;
				}
			}
		}
	}
</style>